import { createI18n } from 'vue-i18n';

export const i18n = new createI18n({
  locale: 'en', // set initial locale
  fallbackLocale: 'en',
  messages: {}, // set locale messages
  silentTranslationWarn: true,
  allowComposition: true,
});
